import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

class InsuranceFilterMenu extends Component {
  constructor(props) {
    super(props);
      this.click = this.click.bind(this);
      this.arrToObj = this.arrToObj.bind(this);
      this.title = props.title[0].toLowerCase();
      this.state = {
        anchorEl: null,
      };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if(newProps.title !== this.title) {
      if(newProps.title !== undefined && newProps.title.length !== 0) {
        this.title = newProps.title[0].toLowerCase();
      }
    }
  }

  click(e) {
    this.props.onChange({
      term: this.props.term,
      title: [e.target.innerText.trim()],
      code: e.target.innerText.trim(),
      id: ""
    });
    this.setState({ anchorEl: null });
  }

  arrToObj(item) {
    const obj = {onClick: this.click, primaryText: item};
    return obj;
  }

  handleClick = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <>
        <Button onClick={this.handleClick}
          endIcon={<Icon>arrow_drop_down</Icon>}
        >
          {this.title}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
        >
          {this.props.items.map((item, index) => (
            <MenuItem key={index} onClick={this.click}>
              {item}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
}

InsuranceFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  term: PropTypes.string.isRequired,
};

export default InsuranceFilterMenu;